import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Appointment = ApiSchemas['AppointmentPresenter']

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/appointment/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListAppointmentDto']) {
    return wrapEndpoint(() =>
      client.GET('/appointment', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['CreateAppointmentDto']) {
    return wrapEndpoint(() =>
      client.POST('/appointment', {
        body,
      }),
    )
  },
  async reschedule(id: number, body: ApiSchemas['RescheduleAppointmentDto']) {
    return wrapEndpoint(() =>
      client.POST('/appointment/{id}/reschedule', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async update(id: number, body: ApiSchemas['UpdateAppointmentDto']) {
    return wrapEndpoint(() =>
      client.PUT('/appointment/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async delete(id: number) {
    return wrapEndpoint(() =>
      client.DELETE('/appointment/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
